export const GAPS_EVIDENCES_DATA = [
  {
    key: '1',
    gapId: 'GAP-001',
    gapDescription: 'Missing data backup procedures',
    riskLevel: 'High',
    evidenceType: 'Documentation',
    evidenceDescription: 'Backup policy document required',
    evidenceStatus: 'Pending',
    validationDate: '2024-01-15',
    validator: 'IT Auditor'
  },
  {
    key: '2',
    gapId: 'GAP-002',
    gapDescription: 'Inadequate access logging',
    riskLevel: 'Medium',
    evidenceType: 'System Logs',
    evidenceDescription: 'Access log reports for Q4 2023',
    evidenceStatus: 'Validated',
    validationDate: '2024-01-10',
    validator: 'Security Team'
  },
  {
    key: '3',
    gapId: 'GAP-003',
    gapDescription: 'Missing incident response plan',
    riskLevel: 'Critical',
    evidenceType: 'Policy',
    evidenceDescription: 'Incident response procedures document',
    evidenceStatus: 'In Review',
    validationDate: '2024-01-20',
    validator: 'Compliance Officer'
  }
];
